module.exports = __webpack_public_path__ + "static/media/banner-feature-favepay-accept-one-percent.3de1c8c9.png";